import React from "react";
import { Grid } from "@material-ui/core";
import Tab from "../../components/UI/OrderTabbedPanel/TabbedPanel";
import SingleOrder from "./SingleOrder/SingleOrder";
import BulkOrder from "./BulkOrder/BulkOrder";
import "./ChangeOrderInterval.css";

const ChangeOrderInterval = () => {
  const tabs = [
    {
      index: 0,
      label: "تکی",
      value: <SingleOrder />,
    },
    {
      index: 1,
      label: "گروهی / اکسل",
      value: <BulkOrder />,
    },
  ];

  return (
    <div className="row justify-content-center">
      <Grid lg={11} xs={11}>
        <Tab tabs={tabs} />
      </Grid>
    </div>
  );
};

export default ChangeOrderInterval;
